<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":true,"host":utils.getMainHost(),"pageId":"pnsline","email":"test@37.com","bindPopupState":false,"commonTipState":false,"bindSuccState":false,"commonTipsContent":"通用提示文案","serverId":"","serverName":"S1-伺服器名","roleId":"","roleName":"一个角色","serverList":[{sid: "239169", id: "10001", sname: "千手修羅"}],"roleList":[{roleID:"32323",roleName:"一个角色名"}],"roleIndex":0,"canModify":true,"code":"","isNeedScale":false,"sid":"","infoPopupState":false,"gameId":191,"pageName":"PNS全球LINE官方账号推广页","hasRoleServerList":[],"awardPopupState":false,"awardPopupContent":`奖励1<br/>奖励2`,"isEdit":true,"showEmailCollect":true,"discordCode":`Code: {0)
/bindtopwar
code:COX4vAJtMZeXPhq33undtgQdPyNAGotaUilVzRYAeYMZxxV4xCDu/8BMuNwWNdGw`,"discordAccount":`Discord账号`,"discordTime":`00:59:00`,"discordBindState":0,"discordAwardState":0,"discordIsFirstAward":true,"lineSerialCode":``,"lineAccountName":``,"lineDeepLink":``,"lineOfficialAccountName":`马楼东`,"lineIsBind":false,"phoneCodeList":[{"Area": "Canada","PhoneCode": "1","AreaCode": "CA"}],"phone":`12321`,"phoneCode":``,"phoneAreaCode":``,"phoneIpAreaCode":``,"showPhoneCollect":true,"previewPopup":``,"facebookRoleId":``,"facebookBindStatus":false,"facebookServerId":``,"facebookDeepLink":``,"facebookPageName":``,"facebookServerName":``,"facebookRoleName":``,"facebookServerSid":``,"isFacebookCollect":false,"btnColor":`#9b2203`,"moduleColorUp":`#f4e2c7`,"moduleColorDown":`#b2ac9f`,"pageColor":`#342c3a`,"welfareIconColorUp":`#ffffff`,"welfareIconColorDown":`#ffffff`,"welfareBgColorUp":`#efbe61`,"welfareBgColorDown":`#6e4837`,"mainTitleColorUp":`#fbf8f4`,"mainTitleColorDown":`#f0d0d0`,"collectRights":[],"titleShadowColor":`#935702`,"loginAccount":`测试账号名称`},"ja-JP":{"isLogin":true,"host":utils.getMainHost(),"pageId":"pnsline","email":"test@37.com","bindPopupState":false,"commonTipState":false,"bindSuccState":false,"commonTipsContent":"通用提示文案","serverId":"","serverName":"S1-伺服器名","roleId":"","roleName":"一个角色","serverList":[{sid: "239169", id: "10001", sname: "千手修羅"}],"roleList":[{roleID:"32323",roleName:"一个角色名"}],"roleIndex":0,"canModify":true,"code":"","isNeedScale":false,"sid":"","infoPopupState":false,"gameId":191,"pageName":"PNS全球LINE官方账号推广页","hasRoleServerList":[],"awardPopupState":false,"awardPopupContent":`奖励1<br/>奖励2`,"isEdit":true,"showEmailCollect":true,"discordCode":`Code: {0)
/bindtopwar
code:COX4vAJtMZeXPhq33undtgQdPyNAGotaUilVzRYAeYMZxxV4xCDu/8BMuNwWNdGw`,"discordAccount":`Discord账号`,"discordTime":`00:59:00`,"discordBindState":0,"discordAwardState":0,"discordIsFirstAward":true,"lineSerialCode":``,"lineAccountName":``,"lineDeepLink":``,"lineOfficialAccountName":`马楼东`,"lineIsBind":false,"phoneCodeList":[{"Area": "Canada","PhoneCode": "1","AreaCode": "CA"}],"phone":`12321`,"phoneCode":``,"phoneAreaCode":``,"phoneIpAreaCode":``,"showPhoneCollect":true,"previewPopup":``,"facebookRoleId":``,"facebookBindStatus":false,"facebookServerId":``,"facebookDeepLink":``,"facebookPageName":``,"facebookServerName":``,"facebookRoleName":``,"facebookServerSid":``,"isFacebookCollect":false,"btnColor":`#9b2203`,"moduleColorUp":`#f4e2c7`,"moduleColorDown":`#b2ac9f`,"pageColor":`#342c3a`,"welfareIconColorUp":`#ffffff`,"welfareIconColorDown":`#ffffff`,"welfareBgColorUp":`#efbe61`,"welfareBgColorDown":`#6e4837`,"mainTitleColorUp":`#fbf8f4`,"mainTitleColorDown":`#f0d0d0`,"collectRights":[],"titleShadowColor":`#935702`,"loginAccount":`测试账号名称`}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['ja-JP']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      const router = Router();
if (/^template/.test(pageData.pageId)) {
  pageData.pageId = 'testInfoLine1'
}

// 显示的高度大于宽度时：跳转竖版页面
if (window.innerWidth < window.innerHeight && router.hasRoute("m")) {
  router.gotoRouter("/m");
}

try {
  document.getElementsByName(
    "viewport"
  )[0].content = `width=device-width,initial-scale=1,viewport-fit=cover,maximum-scale=1,user-scalable=no,height=${window.innerHeight}`;
} catch (e) {
  console.error(e)
}

try {
  window.activityDataLayer.push({
    eventName: 'view_page',
    eventType: pageData.pageName,
    gameId: pageData.gameId,
    aid: pageData.pageId,
  })
} catch (e) {
  console.error(e)
}

// 默认伺服器列表
const defaultServerList = [
  {
    sid: 0,
    id: 0,
    sname: langData.pleaseSelectServer
  },
]

// 默认角色列表
const defaultRoleList = [{
  roleID: 0,
  roleName: langData.pleaseSelectRole
}]

// 重设数据（数据可能是调试状态）
const resetData = () => {
  pageData.showEmailCollect = true;
  pageData.isEdit = false;
  pageData.isLogin = false
  pageData.serverId = ''
  pageData.serverName = ''
  pageData.roleId = ''
  pageData.roleName = ''
  pageData.roleIndex = 0
  pageData.serverList = _.cloneDeep(defaultServerList)
  pageData.hasRoleServerList = []
  pageData.roleList = _.cloneDeep(defaultRoleList)
  pageData.serverTitle = langData.serverTitle
  pageData.roleTitle = langData.roleTitle
  pageData.bindSuccState = false
  pageData.bindPopupState = false
  pageData.commonTipState = false
  pageData.canModify = true
  pageData.email = ''
  pageData.code = ''
  pageData.discordBindState = 0;
  pageData.discordAwardState = 0;
  pageData.discordCode = "";
  pageData.discordTime = "";
  pageData.discordAccount = "";
  pageData.discordIsFirstAward = true;
  pageData.lineSerialCode = "";
  pageData.lineAccountName = "";
  pageData.lineDeepLink = "";
  pageData.lineOfficialAccountName = "";
  pageData.lineIsBind = false
  pageData.fbSerialCode = "";
  pageData.fbAccountName = "";
  pageData.fbDeepLink = "";
  pageData.fbOfficialAccountName = "";
  pageData.fbIsBind = false;
  pageData.phoneCode = "";
  pageData.phone = "";
  pageData.phoneAreaCode = "";
  pageData.phoneIpAreaCode = "";
  pageData.phoneCodeList = [];
  pageData.showPhoneCollect = true;
  pageData.previewPopup = ``;
  pageData.collectRights = []
}

// 检测登录态
const checkLoginState = async () => {
  let res = await request.getJSON(utils.getUserJsonApi(pagePlatform))
  if (res?.result == 1) {
    window.activityDataLayer.push({
      eventName: 'login',
      loginAccount: res.data.LOGIN_ACCOUNT,
      uid: res.data.UID || res.data.USER_ID,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    })
  }
  pageData.loginAccount =  res?.data?.LOGIN_ACCOUNT || ''
  return res?.result == 1
}

// 页面初始化
const init = async () => {
  resetData()
  let isLogin = await checkLoginState()
  if (isLogin) {
    pageData.isLogin = true
    const basicRes = await Promise.all([initActivityInfo(), initServerList()])
    if (!basicRes[0] || !basicRes[1]) return
    let matchServer = autoMatchLinkServer()
    if (!matchServer) return
    let getRoleListRes = await initRoleList(pageData.serverId)
    if (!getRoleListRes) return
    autoMatchLinkRole()
    if (pageData.roleList.length == 2) {
      pageData.roleId = pageData.roleList[1].roleID
      pageData.roleName = pageData.roleList[1].roleName
      pageData.roleIndex = 1
    }
  }
}

// 初始化活动信息
const initActivityInfo = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'basic'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res?.result == 1) {
    pageData.canModify = res.data.allow_edit == 1
    pageData.email = res.data.email
    pageData.showEmailCollect = (!pageData.email)

    pageData.discordBindState = res.data.discord_bind_status;
    pageData.discordAwardState = res.data.discord_award_status;
    pageData.discordCode = res.data.discord_code;
    pageData.discordTime = +(res.data.discord_code_expire_time + '000');
    pageData.discordAccount = res.data.discord_nickname;
    pageData.discordIsFirstAward = res.data.discord_first_bind_award == 1;

    pageData.lineSerialCode = res.data.line_serial_code || "";
    pageData.lineAccountName = res.data.line_account_name || "";
    pageData.lineDeepLink = res.data.line_deep_link || "";
    pageData.lineOfficialAccountName =
      res.data.line_official_account_name || "";
    pageData.facebookPageName = res.data.facebook_page_name || "";
    pageData.facebookDeepLink = res.data.facebook_deep_link || "";
    pageData.facebookBindStatus = !!res.data.facebook_bind_status;
    pageData.isFacebookCollect = res.data.collect_type === 'facebook';
    // 如果是bind_data为数组，说明未绑定角色
    if (Array.isArray(res.data.bind_data) || !res.data?.bind_data) {
      pageData.facebookRoleId = "";
      pageData.facebookServerId = "";
      pageData.facebookServerName = "";
      pageData.facebookRoleName = "";
      pageData.facebookServerSid = "";
    } else {
      pageData.facebookRoleId = res.data.bind_data?.role_id || "";
      pageData.facebookServerId = res.data.bind_data?.server_id || "";
      pageData.facebookServerName = res.data.bind_data?.server_name || "";
      pageData.facebookRoleName = res.data.bind_data?.role_name || "";
      pageData.facebookServerSid = res.data.bind_data?.server_sid || "";
      pageData.serverId = res.data.bind_data?.server_id || "";
      pageData.serverName = res.data.bind_data?.server_name || "";
      pageData.roleId = res.data.bind_data?.role_id || "";
      pageData.roleName = res.data.bind_data?.role_name || "";
    }
    const urlSerialCode = utils.getUrlParams('serial_code') || '';
    if (pageData.lineSerialCode) {
      pageData.lineIsBind = true;
    } else if (urlSerialCode) {
      pageData.lineSerialCode = urlSerialCode;
    }
    pageData.phoneCodeList = res.data.codes_list || [];
    // 取第一个默认值
    pageData.phoneIpAreaCode = res.data.clientip_area_code || "";
    let firstVal = {}
    if (pageData.phoneIpAreaCode) { // 根据ip给初值
      firstVal = pageData.phoneCodeList?.find(option => option.AreaCode === pageData.phoneIpAreaCode)
    } else {
      firstVal = pageData.phoneCodeList?.[0]
    }
    pageData.phoneCode = res.data.phone_code || firstVal?.PhoneCode || "";
    pageData.phoneAreaCode = res.data.area_code || firstVal?.AreaCode || "";
    pageData.phone = res.data.phone || "";
    pageData.showPhoneCollect = (!pageData.phone);
    pageData.collectRights = res.data.collect_rights.map(item => item.rightsId)
  }
  return res?.result == 1
}

// 领discord奖励
const getDiscordAward = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'discordAward'), {
    params: JSON.stringify({
      role_id: pageData.roleId,
      role_name: encodeURIComponent(pageData.roleName),
      server_sid: pageData.sid
    }),
  })
  if (res.result != 1) {
    pageData.commonTipState = true;
    pageData.commonTipsContent = getLangTxt(res.code, res.msg);
    return;
  }
  pageData.commonTipState = true;
  pageData.commonTipsContent = langData.hasGift
  await initActivityInfo();
}

// 初始化服务器列表
const initServerList = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listServerNew'), {
    params: JSON.stringify({
      gameId: pageData.gameId,
      server_limit_recent: 10,
    }),
  })
  if (res?.result == 1) {
    pageData.serverList = res.data?.all_servers || []
    pageData.hasRoleServerList = res.data?.recent_servers || []
  }
  return res?.result == 1
}

// 初始化角色列表
const initRoleList = async (serverId) => {
  pageData.roleList = _.cloneDeep(defaultRoleList)
  let res = await request.getJSON(
    utils.getActivityApi(pagePlatform, pageData.pageId, 'getMobileGameRole'), {
      params: JSON.stringify({
        server_id: serverId
      })
    }
  );
  if (res?.result == 1) {
    pageData.roleList.push(...res.data)
  }
  return res?.result == 1
}

// 自动匹配链接上的伺服器参数
const autoMatchLinkServer = () => {
  let linkServer = utils.getUrlParams('serverId')
  let cookieServer = utils.getCookie('email_c_sid')
  if (!linkServer && !cookieServer) return
  // fbCollect避免假绑定
  if (pageData.isFacebookCollect) return
  let res = false
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkServer) {
      pageData.serverId = pageData.serverList[i].sid
      pageData.serverName = pageData.serverList[i].sname
      pageData.sid = pageData.serverList[i].id
      res = true
      break
    }
  }
  if (res) return res

  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == cookieServer) {
      pageData.serverId = pageData.serverList[i].sid
      pageData.serverName = pageData.serverList[i].sname
      pageData.sid = pageData.serverList[i].id
      res = true
      break
    }
  }
  return res
}

// 自动匹配链接上的角色参数
const autoMatchLinkRole = () => {
  let linkRole = utils.getUrlParams('roleId') || utils.getUrlParams('roleID')
  let cookieRole = utils.getCookie('email_c_roleId')
  if (!linkRole && !cookieRole) return
  let res = false
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkRole) {
      pageData.roleId = pageData.roleList[i].roleID
      pageData.roleName = pageData.roleList[i].roleName
      pageData.roleIndex = i
      break
    }
  }

  if (res) return res
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == cookieRole) {
      pageData.roleId = pageData.roleList[i].roleID
      pageData.roleName = pageData.roleList[i].roleName
      pageData.roleIndex = i
      res = true
      break
    }
  }
}

init()

// 点击时检测是否已登录
const clickCheckIsLogin = () => {
  if (!pageData.isLogin) {
    window.location.href = utils.getLoginUrlApi(pagePlatform, pageData.gameId);
    return;
  }
  return true;
}

// 点击时检测是否已经选择角色
const clickCheckIsBind = () => {
  let res =
    pageData.serverId &&
    pageData.roleId &&
    pageData.serverId !== '0' &&
    pageData.roleId !== '0'
  if (!res) {
    pageData.bindPopupState = true
  }
  return res
}

provide('clickCheckIsLogin', clickCheckIsLogin)
provide('initRoleList', initRoleList)
provide('clickCheckIsBind', clickCheckIsBind)
provide('initActivityInfo', initActivityInfo)
provide('getDiscordAward', getDiscordAward)

watch(
  () => pageData.bindPopupState,
  (value) => {
    if (value) {
      try {
        window.dataLayer.push({
          event: 'uploadPoint',
          eventName: '展示绑定弹窗',
          aid: pageData.pageId,
        })
      } catch (error) {}
    }
  }
)

// 打点

watch(
  () => pageData.roleId,
  (value) => {
    if (value) {
      try {
        window.__updatePointUploadCookie('role_id', value)
      } catch (error) {}
    }
  }
)

watch(
  () => pageData.roleName,
  (value) => {
    if (value) {
      try {
        window.__updatePointUploadCookie('role_name', value)
      } catch (error) {}
    }
  }
)

watch(
  () => pageData.serverId,
  (value) => {
    if (value) {
      try {
        window.__updatePointUploadCookie('server_id', value)
      } catch (error) {}
    }
  }
)
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    #app {
  position: relative;
  width: 100%;
  height: 100%;
}

.customer-scroll-bar::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar {
  width: 12px;
  height: 4px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar-thumb,
  .customer-scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-track,
  .customer-scroll-bar::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:hover,
  .customer-scroll-bar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:active,
  .customer-scroll-bar::-webkit-scrollbar-thumb:active {
  background-color: rgba(0, 0, 0, 0.9);
}



  </style>
  